import {
  Component,
  AfterViewInit,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Inject,
  HostListener,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {} from 'events';
import { thankYouMessage } from 'src/app/common-class/survey-messages';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { CommonSetting, OfflineSurvey } from '../../common-class/survey';
import { Observable, Subscription, timer } from 'rxjs';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { EncryptionAndDecryption } from '../../COMMON-LOGIC/EncryptionAndDecryption';
import * as Highcharts from 'highcharts';
import HC_More from 'highcharts/highcharts-more';
import HC_Exporting from 'highcharts/modules/exporting';
import { PostMessgesData } from 'src/app/common-class/page-question';
HC_Exporting(Highcharts);
HC_More(Highcharts);

// Define interfaces outside the class
interface CategoryScoreItem {
  CategoryName: string;
  PercentageEarned: number;
  AvgScorePercent: number;
}

// Explicitly allow any type for Highcharts configurations
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type HighchartsSeriesConfig = any;

@Component({
  selector: 'app-thank-you-message',
  templateUrl: './thank-you-message.component.html',
  styleUrls: ['./thank-you-message.component.css'],
})
export class ThankYouMessageComponent implements OnInit, AfterViewInit {
  @Input() ThankYouMessage: thankYouMessage;
  @Input() ResponseRecorded: string;
  @Input() PoweredByText: string;
  @Input() isReopenResponse: boolean;
  @Input() ReopenText: string;
  @Input() surveyWidthType: number;
  @Input() isMobile: boolean;
  @Input() SurveyLogoImageUrl: string;
  @Input() SurveyLogoAlign: number;
  @Input() isShowPartial: boolean = false;
  @Input() isPowredByClient: boolean = false;
  @Input() RecNo: number;
  @Input() IsMobile: boolean;
  @Input() IsPreview: boolean;
  @Input() ToasterMessageForPreview: string;
  @Output() StartNewResponse: EventEmitter<unknown> = new EventEmitter();
  @Output() PreviewPrintHandling: EventEmitter<unknown> = new EventEmitter();
  @Output() EditResponceHandling: EventEmitter<unknown> = new EventEmitter();
  isTablet: boolean;
  @Input() surveyData: unknown;
  href: string;
  isRTL: boolean;
  eleMinHeight: unknown;
  thankYouGifURL: string;
  isPreview: boolean = false;
  selectedLang: number;
  ChartData: Highcharts.Chart;
  urlParam: string;
  isOfflineSurvey: boolean = false;
  toasterMessageForPreview: string;

  private timer: Observable<unknown>;
  private subscription: Subscription;
  OfflineResponseData: unknown[] = [];
  postMessgesData: PostMessgesData;

  constructor(
    private service: ParticipationDataService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private offlineSurvey: OfflineSurvey,
    @Inject(LOCAL_STORAGE) private storage: StorageService,
    private commonSetting: CommonSetting,
  ) {
    this.offlineSurvey = this.service.getOfflineSurvey();
    if (this.offlineSurvey != undefined) {
      this.isOfflineSurvey = this.offlineSurvey.isOfflineSurvey;
    }
  }

  ngOnInit() {
    // Add class to body element using native DOM
    document.body.classList.add('hideBodyScroll');

    this.service.setCommonSetting(this.commonSetting);
    this.isTablet = this.commonSetting.isTablet;

    if (this.IsPreview && window.location.href.indexOf('&isFromSB=1') == -1) {
      const objThankYou = document.querySelector(
        '.Plat_Alert_ThankYou.Warning.Plat_Alert_custom.For_ThankYou',
      ) as HTMLElement;
      setTimeout(() => {
        if (objThankYou) {
          objThankYou.style.display = 'block';
        }
      }, 150);
      setTimeout(() => {
        this.closeAlert();
      }, 10000);
    }

    this.isRTL = this.service.isRTL;
    this.thankYouGifURL = 'static/images/ThankYouPage.gif?' + this.ThankYouMessage?.SurveyURL;

    const head = document.getElementsByTagName('head')[0];
    const node = document.createElement('script'); // creates the script tag
    node.text =
      '     document.addEventListener("DOMContentLoaded", function () {' +
      this.ThankYouMessage?.customScript +
      '});'; // Changed from jQuery to native DOM
    node.type = 'text/javascript'; // set the script type
    head.appendChild(node);

    this.setTimer();

    setTimeout(() => {
      if (
        this.ThankYouMessage.CategoryScore != undefined &&
        this.ThankYouMessage.CategoryScore != ''
      ) {
        this.displayCategoryGraph(this.ThankYouMessage.CategoryScore);
      }
    }, 200);

    if (this.isOfflineSurvey) {
      let k = '';
      this.activatedRoute.queryParams.subscribe(async (params) => {
        k = params['k'];
      });
      let encryptedData = this.storage.get('ResponseData_' + k) || [];

      if (encryptedData.length > 0) {
        encryptedData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', encryptedData);
        this.OfflineResponseData = JSON.parse(encryptedData);
      }
    }

    if (this.isShowPartial) {
      if (window.parent) {
        window.parent.parent.scrollTo(0, 0);
      }
    }
  }
  defaultBtnAlignWidth() {
    if (!this.isTablet && !this.isMobile) {
      const surveyDetails = this.surveyData as any;
      if (surveyDetails?.SurveyDetails?.SurveyWidthType == 1) {
        return { 'min-width': '735.938px', 'max-width': '735.938px' };
      } else if (surveyDetails?.SurveyDetails?.SurveyWidthType == 2) {
        return { 'min-width': '995.469px', 'max-width': '995.469px' };
      } else {
        return { 'min-width': '85%', 'max-width': '85%' };
      }
    } else if (this.isTablet) {
      return { 'min-width': '713px', 'max-width': '713px' };
    }
  }

  closeAlert() {
    const alertElements = document.getElementsByClassName('Plat_Alert_ThankYou');

    for (let i = 0; i < alertElements.length; i++) {
      const element = alertElements[i] as HTMLElement;

      // Animate using JavaScript
      const animateRight = (element: HTMLElement) => {
        let position = 0;
        const intervalId = setInterval(() => {
          if (position >= 1000) {
            clearInterval(intervalId);
            element.style.display = 'none';
            element.style.right = '0px';
          } else {
            position += 20; // Adjust speed of animation
            element.style.right = `-${position}px`;
          }
        }, 10);
      };

      animateRight(element);
    }
  }

  sendCatGraphImage(base64Img: string, intRecNo: number) {
    if (base64Img != undefined && base64Img != '') {
      sessionStorage.setItem('CatGraph_' + intRecNo, base64Img);
    }
  }
  checkIfisIpad() {
    return (
      /iPad/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
  }
  EditResponce() {
    document.body.classList.remove('hideBodyScroll');
    this.EditResponceHandling.emit({ name: 'PreviewEdit' });
  }

  PrintRespponseResult(type: string) {
    this.PreviewPrintHandling.emit({ name: type });
  }

  ngAfterViewInit() {
    // Add event listener for close button
    const closeBtn = document.getElementById('close-btn-thankyou');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        this.closeAlert();
      });
    }

    // Document ready equivalent using pure JavaScript
    if (
      this.ThankYouMessage.isPrint == '0' &&
      this.ThankYouMessage.isRedirect == '0' &&
      this.ThankYouMessage.isThankYou == '0' &&
      this.ThankYouMessage.isBarGraph == '0'
    ) {
      if (window.parent) parent.window.close();
      window.close();
    }

    if (this.service.getGroupType()?.toLowerCase() == 'preview') {
      const editLink = document.getElementById('EditLinkID');
      if (editLink) {
        editLink.addEventListener('click', () => {
          this.EditResponce();
        });
      }
    }

    // Using window innerWidth/innerHeight instead of jQuery
    const window_width = window.innerWidth;
    const window_height = window.innerHeight;

    let appParticipationHeight = window_height;
    const appParticipation = document.querySelector('.app-participation') as HTMLElement;
    if (document.body.classList.contains('PMPreview') && appParticipation) {
      appParticipationHeight = appParticipation.offsetHeight;
    }

    // Handle viral links
    if (window_width <= 900 || appParticipationHeight < 600) {
      const chainLink = document.querySelector('#chainLink.activate_modal') as HTMLElement;
      const mobViralLink = document.querySelector('#mobViralLink.thnk-option') as HTMLElement;

      if (chainLink) {
        chainLink.setAttribute('href', 'javascript:void(0);');

        // Remove any existing event listeners (equivalent to unbind)
        const oldElement = chainLink.cloneNode(true) as HTMLElement;
        if (chainLink.parentNode) {
          chainLink.parentNode.replaceChild(oldElement, chainLink);
        }

        oldElement.setAttribute(
          'onclick',
          `javascript:window.open('${this.ThankYouMessage.ViralURL.replace(/'/g, '')}','_blank')`,
        );
      }

      if (mobViralLink) {
        mobViralLink.setAttribute(
          'onclick',
          `javascript:window.open('${this.ThankYouMessage.ViralURL.replace("/'/g", '')}','_blank')`,
        );
      }
    } else {
      const chainLink = document.querySelector('#chainLink.activate_modal') as HTMLElement;
      if (chainLink) {
        chainLink.setAttribute('href', 'javascript:void(0);');

        chainLink.addEventListener('click', () => {
          const chainModalIframe = document.getElementById(
            'chainmodalIframeDiv',
          ) as HTMLIFrameElement;
          if (chainModalIframe) {
            chainModalIframe.setAttribute('src', this.ThankYouMessage.ViralURL.replace("/'/g", ''));
          }

          const modal_id = chainLink.getAttribute('name') || '';
          this.showModal(modal_id);
        });
      }

      // Handle modal windows
      const modalWindows = document.querySelectorAll('.modalWindow');
      modalWindows.forEach((modal) => {
        const modalElement = modal as HTMLElement;
        const modal_height = modalElement.offsetHeight + 14;
        const modal_width = modalElement.offsetWidth;
        const top = (window_height - modal_height) / 2;
        const left = (window_width - modal_width) / 2;

        modalElement.style.top = top + 'px';
        modalElement.style.left = left + 'px';
      });

      // Handle close modal button
      const closeModalButtons = document.querySelectorAll('.close_modalviral');
      closeModalButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.closeModal('viralinvitepop');
          this.clearChainIframe();
        });
      });
    }

    // Define modal functions
    // These were previously inner functions, now they're component methods

    // Category graph rendering
    if (
      this.ThankYouMessage.CategoryScore != undefined &&
      this.ThankYouMessage.CategoryScore != ''
    ) {
      let base64Img: string;

      setTimeout(() => {
        // We still need to use Highcharts API here
        const chartElement = document.getElementById('dv_CatGraph');
        if (chartElement) {
          // Use Highcharts.Chart for the chart type
          // @ts-expect-error - Highcharts Chart type definition doesn't include renderTo but it exists at runtime
          const chart = Highcharts.charts.find((c) => c.renderTo === chartElement);

          if (chart) {
            const graphData = chart.getSVG();
            base64Img =
              'data:image/svg+xml;base64,' + window.btoa(unescape(encodeURIComponent(graphData)));
          }
        }
      }, 1000);

      setTimeout(() => {
        if (base64Img) {
          // This is accessing a global function, we should replace it with our component method
          this.sendCatGraphImage(base64Img, this.service.getRecNO() as number);
        }
      }, 1001);
    }

    // Handle embedded survey
    setTimeout(() => {
      if (
        window.location !== window.parent.location &&
        document.body.classList.contains('embed-survey')
      ) {
        let docHeight = document.documentElement.scrollHeight;

        const thankYouMsgWrapper = document.querySelector('.thankYouMsgWrapper') as HTMLElement;
        if (thankYouMsgWrapper && thankYouMsgWrapper.offsetHeight !== 0) {
          docHeight = thankYouMsgWrapper.offsetHeight;
        }

        const navigationBand = document.querySelector('.navigation-band') as HTMLElement;
        if (navigationBand && navigationBand.offsetHeight !== 0) {
          docHeight += navigationBand.offsetHeight;
        }

        const embedSurvey = document.querySelector('.embed-survey') as HTMLElement;
        if (embedSurvey) {
          if (embedSurvey.offsetWidth > 600) {
            embedSurvey.classList.add('tBodyPage');
          } else {
            embedSurvey.classList.remove('tBodyPage');
          }
        }

        this.postMessgesData = new PostMessgesData();
        this.postMessgesData.action = 'Submit Button Click';
        this.postMessgesData.data = '';
        this.postMessgesData.height = docHeight + 250;
        this.postMessgesData.width = document.documentElement.scrollWidth;
        this.postMessgesData.embedid = this.service.getEmbedId();

        if (window.parent) {
          window.parent.postMessage(JSON.stringify(this.postMessgesData), '*');
        }

        document.body.style.height = 'auto';

        if (window.screen?.width) {
          if (window.screen.width > 1000 && !this.checkIfisIpad()) {
            if (document.body.classList.contains('embed-survey')) {
              const participationBody = document.getElementById('participationBodyScrollMain');
              if (participationBody) {
                participationBody.style.minHeight = docHeight + 'px';
                participationBody.style.maxHeight = docHeight + 'px';
              }
            }
          }
        }
      }
    }, 200);

    // Check for mobile wrapper
    const mobileWrapper = document.querySelector('.mobile-wrapper');
    if (mobileWrapper) {
      this.calcTyWrapperHt();
    }
    this.bottomfooterPos();
  }

  displayCategoryGraph(jsonData: string): void {
    const parsedData = JSON.parse(jsonData);
    const categories: string[] = [];
    const categoryScoresPercentage: number[] = [];
    const avgScoresPercentage: number[] = [];

    parsedData.forEach((element: CategoryScoreItem) => {
      categories.push(element.CategoryName);
      categoryScoresPercentage.push(element.PercentageEarned);
      avgScoresPercentage.push(element.AvgScorePercent);
    });

    // Use any type for Highcharts configs to avoid complex typing issues
    const seriesForCategoryScoreGraph: HighchartsSeriesConfig[] = [
      {
        name: 'Category Score',
        data: categoryScoresPercentage,
        type: 'bar',
        color: '#7CB5EC',
        pointWidth: 12,
      },
    ];

    this.displayGraph(categories, seriesForCategoryScoreGraph);
  }

  displayGraph(categories: string[], categoriesseries: HighchartsSeriesConfig[]): void {
    let rotation;
    let tickInterval;
    const minHeight = 200;
    const categoryCount = categories.length;

    // Set height for the chart container using native DOM
    const chartContainer = document.getElementById('dv_CatGraph');
    if (chartContainer) {
      if (categoriesseries.length == 1) {
        chartContainer.style.height =
          minHeight + categoryCount * (parseInt(categoriesseries[0].pointWidth, 10) + 5) + 'px';
      } else {
        chartContainer.style.height =
          minHeight + categoryCount * (parseInt(categoriesseries[0].pointWidth, 10) + 20) + 'px';
      }
    }

    let min = 0;
    let max = 100;
    max = Math.max(...categoriesseries[0].data);
    min = Math.min(...categoriesseries[0].data);
    if (categoriesseries.length === 2) {
      if (Math.max(...categoriesseries[1].data) > max) max = Math.max(...categoriesseries[1].data);
      if (Math.min(...categoriesseries[1].data) < min) min = Math.min(...categoriesseries[1].data);
    }
    if (min > 0) min = 0;
    if (max > 0) max = 100;
    if (min < 0 && max <= 0) min = -100;
    if (max < 0) max = 0;
    if (this.isMobile) {
      rotation = -50;
      tickInterval = 25;
    } else {
      rotation = 0;
      tickInterval = 20;
    }
    this.ChartData = Highcharts.chart('dv_CatGraph', {
      chart: {
        type: 'bar',
        alignTicks: false,
      },
      title: {
        text: '',
      },
      exporting: {
        enabled: false,
      },
      xAxis: {
        labels: {
          step: 1,
        },
        categories: categories,
        title: {
          text: null,
          style: {
            fontSize: '12px',
            fontWeight: '400',
            fontFamily: 'Proxima N W01 Smbd',
          },
        },
      },
      yAxis: {
        min: min,
        minRange: 20,
        max: max === 0 ? null : max,
        tickInterval: tickInterval,
        title: {
          text: null,
          align: 'high',
          style: {
            fontSize: '12px',
            fontWeight: '400 !important',
            fontFamily: 'Proxima N W01 Smbd !important',
          },
        },
        labels: {
          overflow: 'justify',
          style: {
            fontSize: '12px',
            fontWeight: '400 !important',
            fontFamily: 'Proxima N W01 Smbd !important',
          },
          rotation: rotation,
        },
      },
      tooltip: {
        valueSuffix: ' %',
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            crop: false,
            allowOverlap: true,
            style: {
              fontSize: '12px',
              fontWeight: '600 !important',
              fontFamily: 'Proxima N W01 Smbd !important',
            },
            format: '{y} %',
          },
        },
        series: {
          events: {
            legendItemClick: function (e) {
              e.preventDefault();
            },
          },
        },
      },
      legend: {
        align: 'left',
        verticalAlign: 'top',
        x: 0,
        y: 0,
        itemStyle: {
          cursor: 'default',
        },
      },
      credits: {
        enabled: false,
      },
      series: categoriesseries,
    });
    if (this.ChartData) {
      setTimeout(() => {
        const graphData = this.ChartData.getSVG();
        const base64Img = EncryptionAndDecryption.EncryptionData('123456$#@$^@1ERF', graphData);
        this.sendCatGraphImage(base64Img, this.RecNo);
      }, 2000);
    }
  }

  calcTyWrapperHt() {
    if (
      !(
        window.location !== window.parent.location &&
        document.body.classList.contains('embed-survey')
      )
    ) {
      const windowHeight = window.innerHeight;
      const footerElement = document.querySelector('.thank-you-footer') as HTMLElement;

      const footerHeight = footerElement ? footerElement.offsetHeight : 0;
      const tyMsgWrapperHt = windowHeight - footerHeight; //80 is the padding of ty wrapper

      const thankYouMsgWrapper = document.querySelector('.thankYouMsgWrapper') as HTMLElement;
      if (thankYouMsgWrapper) {
        thankYouMsgWrapper.style.minHeight = tyMsgWrapperHt + 'px';
      }
    }
  }

  OfflineDashboard() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    document.title = 'Offline Home -' + this.offlineSurvey.surveyno;
    const path = 'offline?' + this.GetUrlData(false);
    this.router.navigateByUrl(path);
  }

  RecordResponse() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.StartNewResponse.emit();
  }

  GetUrlData(isLoading: boolean): string {
    this.activatedRoute.queryParams.subscribe(async (params) => {
      const k = params['k'];
      let Uid = '';
      let Dir = '';
      let lang = params['lang'] == '' || params['lang'] == undefined ? '0' : params['lang'];
      const goBackQuota =
        params['isGoBackQuota'] == '' || params['isGoBackQuota'] == undefined
          ? ''
          : '&isGoBackQuota=true';
      const isEmbedMobile =
        params['isEmbedMobile'] == '' || params['isEmbedMobile'] == undefined
          ? ''
          : '&isEmbedMobile=1';
      const isPartial =
        params['isPartial'] == '' || params['isPartial'] == undefined ? '' : '&isPartial=True';

      if (lang == undefined) {
        lang = params['lang'] == '' || params['lang'] == undefined ? '0' : params['lang'];
      }

      let status =
        params['status'] != undefined ||
        params['status'] != null ||
        params['Status'] != undefined ||
        params['Status'] != null
          ? '&status=preview'
          : '';

      if (status == '&status=preview') {
        this.isPreview = true;
        const isThankYou =
          params['isThankYou'] == '' || params['isThankYou'] == undefined
            ? ''
            : '&isThankYou=' + params['isThankYou'];
        const type =
          params['type'] == '' || params['type'] == undefined ? '' : '&type=' + params['type'];
        const msgId =
          params['msgId'] == '' || params['msgId'] == undefined ? '' : '&msgId=' + params['msgId'];
        status = status + isThankYou + type + msgId;
      }

      if (isLoading) {
        Uid =
          params['Uid'] == '' || params['Uid'] == undefined ? '' : '&responseUID=' + params['Uid'];
        Dir = params['Dir'] == '' || params['Dir'] == undefined ? '' : '&Dir=' + params['Dir'];
      }

      this.urlParam =
        'k=' + k + '&lang=' + lang + Uid + status + Dir + goBackQuota + isEmbedMobile + isPartial;
      this.selectedLang = parseInt(lang, 10);
    });
    return this.urlParam;
  }

  public setTimer() {
    if (this.isOfflineSurvey) {
      this.timer = timer(1 * 1000 * this.offlineSurvey.Thankyoumessagetimeout);

      if (this.subscription) {
        this.subscription.unsubscribe();
      }
      this.subscription = this.timer.subscribe(() => {
        setTimeout(() => {
          document.title = 'Offline Home -' + this.offlineSurvey.surveyno;
          const path = 'offline?' + this.GetUrlData(false);
          this.router.navigateByUrl(path);
        }, 100);
      });
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.bottomfooterPos();
  }

  bottomfooterPos() {
    const docHeight = window.innerHeight;
    const footerDiv = document.querySelector('.main-footer-div.thank-you-footer') as HTMLElement;
    if (footerDiv) {
      const footerHeight = footerDiv.offsetHeight;
      const footerTop = footerDiv.getBoundingClientRect().top + window.scrollY;
      const footerBottom = footerTop + footerHeight;
      if (footerBottom < docHeight) {
        const marginTop = docHeight - footerBottom + 30;
        footerDiv.style.marginTop = marginTop + 'px';
      }
    }
  }

  // Add the modal methods that were referenced
  private closeModal(modalId: string): void {
    const mask = document.getElementById('mask');
    if (mask) {
      this.fadeOut(mask, 500);
    }

    const modal = document.getElementById(modalId);
    if (modal) {
      this.fadeOut(modal, 500);
    }
  }

  private clearChainIframe(): void {
    const iframe = document.getElementById('chainmodalIframeDiv') as HTMLIFrameElement;
    if (iframe) {
      iframe.setAttribute('src', this.ThankYouMessage.ViralURL);
    }
  }

  private showModal(modalId: string): void {
    const mask = document.getElementById('mask');
    if (mask) {
      mask.style.display = 'block';
      mask.style.opacity = '0';
      this.fadeTo(mask, 500, 0.8);
    }

    const modal = document.getElementById(modalId);
    if (modal) {
      this.fadeIn(modal, 500);

      const modal_height = modal.offsetHeight;
      const modal_width = modal.offsetWidth;
      const top = modal_height / 2;
      const left = modal_width / 2;

      modal.style.top = '50%';
      modal.style.left = '50%';
      modal.style.marginTop = `-${top}px`;
      modal.style.marginLeft = `-${left}px`;
      modal.style.position = 'fixed';
    }
  }

  // Helper animation methods to replace jQuery animations
  private fadeOut(element: HTMLElement, duration: number): void {
    let opacity = 1;
    const interval = 50;
    const gap = interval / duration;

    function fade() {
      opacity = Math.max(0, opacity - gap);
      element.style.opacity = opacity.toString();

      if (opacity <= 0) {
        element.style.display = 'none';
        return;
      }

      setTimeout(fade, interval);
    }

    fade();
  }

  private fadeIn(element: HTMLElement, duration: number): void {
    let opacity = 0;
    const interval = 50;
    const gap = interval / duration;

    element.style.opacity = '0';
    element.style.display = 'block';

    function fade() {
      opacity = Math.min(1, opacity + gap);
      element.style.opacity = opacity.toString();

      if (opacity >= 1) {
        return;
      }

      setTimeout(fade, interval);
    }

    fade();
  }

  private fadeTo(element: HTMLElement, duration: number, targetOpacity: number): void {
    const currentOpacity = parseFloat(window.getComputedStyle(element).opacity);
    const interval = 50;
    const steps = duration / interval;
    const opacityStep = (targetOpacity - currentOpacity) / steps;
    let opacity = currentOpacity;

    function fade() {
      opacity += opacityStep;

      if (
        (opacityStep > 0 && opacity >= targetOpacity) ||
        (opacityStep < 0 && opacity <= targetOpacity)
      ) {
        element.style.opacity = targetOpacity.toString();
        return;
      }

      element.style.opacity = opacity.toString();
      setTimeout(fade, interval);
    }

    fade();
  }
}
